import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ValidatorFn } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GenSharedModule } from 'src/app/generac/shared/shared.module';
import { Shipment } from '../../../../models/auto-ship.model';
import moment from 'moment';

@Component({
  selector: 'gen-auto-ship-shipment-date',
  templateUrl: './auto-ship-shipment-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    GenSharedModule,
  ]
})
export class GenAutoShipShipmentDateComponent {
  shipments: Shipment[] = [];

  @Output() shipmentDatesChange = new EventEmitter<Shipment[]>();
  @Input()
  set numberOfShipments(count: number) {
    const safeCount = Math.max(0, Number(count) || 0);

    this.shipments = Array.from({ length: safeCount }, (_, index) =>
      this.shipments[index] ?? {
        number: index + 1,
        dateControl: new FormControl<Date | null>(
          null,
          this.dateValidator
        )
      }
    );
  }

  private isValidShipmentDate(value: Date | null): boolean {
    if (!value) {
      return false;
    }

    const date = moment(value);
    const today = moment().startOf('day');

    const isMonday = date.day() === 1;
    const isNotInPast = date.isSameOrAfter(today, 'day');
    const isInCurrentYear = date.year() === moment().year();

    return isMonday && isNotInPast && isInCurrentYear;
  }

  dateValidator: ValidatorFn = control =>
    !control.value || this.isValidShipmentDate(control.value)
      ? null
      : { invalidShipmentDate: true };

  desiredDayFilter = (date: Date | null): boolean => this.isValidShipmentDate(date);

  trackByShipmentNumber(index: number, shipment: Shipment): number {
    return shipment.number;
  }

  onShipmentDateChange(event: any): void {
    this.shipmentDatesChange.emit(this.shipments);
  }
}